var map = {
	"./cart.svg": "908e",
	"./cash.svg": "c489",
	"./checked.svg": "2331",
	"./checked2.svg": "aef2",
	"./choice.svg": "5440",
	"./code.svg": "d7a5",
	"./down.svg": "d681",
	"./email.svg": "cbb7",
	"./empty-cart.svg": "31a7",
	"./expand.svg": "c963",
	"./feeder.svg": "328f",
	"./goods.svg": "7421",
	"./lock.svg": "ab00",
	"./love1.svg": "5a24",
	"./love2.svg": "6aa9",
	"./menu.svg": "bd3d",
	"./more.svg": "3dd0",
	"./notice.svg": "fc99",
	"./payment.svg": "ea4f",
	"./phone.svg": "dd82",
	"./position.svg": "15be",
	"./pwd.svg": "15da",
	"./user.svg": "b3b5",
	"./withdrawal.svg": "39b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";